import * as Yup from "yup";

export const learningOutcomesValidation = Yup.object().shape({
  description: Yup.string().required("وارد کردن توضیحات الزامی است"),
  name: Yup.string().required("وارد کردن نام الزامی است"),
});
